import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

interface TagListProps {
  tags?: string[];
}

export default function TagList({ tags }: TagListProps) {
  const { theme } = useTheme();

  if (!tags?.length) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map(tag => (
        <Link
          key={tag}
          to={`/tag/${tag}`}
          className={`
            text-[11px] px-2 py-0.5 rounded-full transition-colors
            ${theme === 'dark'
              ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }
          `}
        >
          #{tag}
        </Link>
      ))}
    </div>
  );
}